import { useEffect, useState } from 'react';
import api from '@/services/api';

const useFetchFlagData = (endURL) => {
	const [ isMounted, setIsMounted ] = useState(false);
	const [ flagData, setFlagData ] = useState(false);
	
	useEffect(() => {
		const getFlagData = async () => {
			await api.get(endURL).then(({ data }) => {
				setFlagData(data.enabled);
			});
		};

		setIsMounted(true);
		if (isMounted) {
			getFlagData();
		}
	}, [ isMounted, flagData ]);

	return flagData;
};

export default useFetchFlagData;